import axios from '@/axios'

const wpBaseUrl = process.env.NODE_ENV === 'development'
  ? window.location.origin
  : process.env.VUE_APP_BASE_SITE_URL;

export default {

  namespaced: true,

  state: {
    token: null,
  },

  getters: {
    token ( state ) {
      return state.token;
    },
  },

  mutations: {
    token ( state, token ) {
      if ( token ) {
        const d = new Date();
        d.setTime( d.getTime() + ( 60 * 60 * 1000 ) ); // now + 1hr
        document.cookie = `jj-auth=${ token }; expires=${ d.toUTCString() }; path=/`;
      } else {
        document.cookie = "jj-auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }
      state.token = token;
    }
  },

  actions: {
    
    async login ({ commit } , payload ) {
      try {
        const response = await axios({
          url: `${ wpBaseUrl }/wp-json/jwt-auth/v1/token`,
          method: 'post',
          data: payload,
          noAuth: true,
        });
        const token = response?.data?.token ?? null;
        if ( token ) {
          commit( 'token', token );
          return { success: true };
        } else {
          commit( 'token', null );
          return { success: false };
        }
      } catch ( e ) {
        return { success: false };
      }
    },

    clear_token ({ commit }) {
      commit( 'token', null );
    },

    init_token_from_cookie ({ commit }) {
      let token = null;
      document.cookie.split( ';' ).forEach( function( el ) {
        let [key,value] = el.split('=');
        if ( key.trim() == 'jj-auth' ) {
          token = value.trim();
        }
      });
      commit( 'token', token );
    },

  },

}
